var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg003C11To20People(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97.96800000000002,
    height: 97.96800000000002,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 422.096845,
    width: 422.096845,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    id: "svg_3",
    d: "m49.541,38.655c1.617,0 3.158,0.338 4.559,0.946c0.105,-2.286 0.893,-4.4 2.157,-6.15c-0.89,-0.186 -1.808,-0.285 -2.748,-0.285l-8.906,0c-0.938,0 -1.856,0.098 -2.739,0.282c1.347,1.869 2.152,4.15 2.165,6.62c1.637,-0.9 3.515,-1.413 5.512,-1.413z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#777f8e",
    id: "svg_4",
    r: 10.496,
    cy: 21.954,
    cx: 49.054
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    id: "svg_5",
    d: "m65.539,50.36c5.342,0 9.67,-4.33 9.67,-9.67c0,-5.342 -4.328,-9.67 -9.67,-9.67c-5.292,0 -9.583,4.251 -9.663,9.524c3.049,1.912 5.187,5.146 5.577,8.9c1.242,0.582 2.623,0.916 4.086,0.916z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    id: "svg_6",
    d: "m32.571,31.019c-5.343,0 -9.671,4.329 -9.671,9.67s4.328,9.669 9.671,9.669c1.892,0 3.651,-0.553 5.143,-1.492c0.475,-3.091 2.132,-5.794 4.499,-7.634c0.01,-0.181 0.027,-0.36 0.027,-0.543c0,-5.341 -4.33,-9.67 -9.669,-9.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    id: "svg_7",
    d: "m71.82,30.813c3.049,1.912 5.187,5.146 5.576,8.901c1.241,0.581 2.623,0.916 4.086,0.916c5.342,0 9.67,-4.329 9.67,-9.67c0,-5.341 -4.328,-9.67 -9.67,-9.67c-5.291,-0.001 -9.582,4.251 -9.662,9.523z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#777f8e",
    id: "svg_8",
    r: 9.671,
    cy: 50.673,
    cx: 49.541
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    id: "svg_9",
    d: "m69.643,51.019l-8.144,0c-0.089,3.258 -1.479,6.192 -3.679,8.301c6.068,1.806 10.509,7.434 10.509,14.082l0,3.092c8.04,-0.297 12.674,-2.573 12.979,-2.729l0.646,-0.328l0.067,0l0,-10.036c0.002,-6.828 -5.552,-12.382 -12.378,-12.382z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    id: "svg_10",
    d: "m85.585,41.289l-8.142,0c-0.088,3.258 -1.479,6.192 -3.678,8.301c6.068,1.806 10.508,7.433 10.508,14.081l0,3.092c8.039,-0.296 12.674,-2.572 12.979,-2.729l0.646,-0.327l0.069,0l0,-10.036c0,-6.827 -5.554,-12.382 -12.382,-12.382z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    id: "svg_11",
    d: "m41.256,59.319c-2.189,-2.099 -3.575,-5.017 -3.677,-8.254c-0.301,-0.022 -0.6,-0.047 -0.908,-0.047l-8.203,0c-6.828,0 -12.383,5.555 -12.383,12.383l0,10.037l0.025,0.155l0.691,0.218c5.227,1.633 9.893,2.383 13.944,2.621l0,-3.031c0.002,-6.647 4.441,-12.275 10.511,-14.082z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    id: "svg_12",
    d: "m53.643,61.003l-8.206,0c-6.828,0 -12.383,5.557 -12.383,12.382l0,10.037l0.026,0.157l0.69,0.216c6.516,2.035 12.177,2.715 16.835,2.715c9.101,0 14.375,-2.595 14.701,-2.76l0.646,-0.328l0.068,0l0,-10.037c0.003,-6.827 -5.551,-12.382 -12.377,-12.382z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    id: "svg_13",
    d: "m16.486,40.938c1.463,0 2.844,-0.335 4.086,-0.916c0.39,-3.755 2.527,-6.99 5.576,-8.902c-0.08,-5.271 -4.371,-9.523 -9.662,-9.523c-5.343,0 -9.671,4.329 -9.671,9.671c0,5.341 4.328,9.67 9.671,9.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    id: "svg_14",
    d: "m24.202,49.899c-2.198,-2.109 -3.589,-5.044 -3.677,-8.303l-8.143,0c-6.828,0.001 -12.382,5.556 -12.382,12.383l0,10.037l0.069,0l0.646,0.327c0.306,0.154 4.939,2.433 12.979,2.728l0,-3.092c0,-6.647 4.439,-12.275 10.508,-14.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    id: "svg_15",
    d: "m27.796,30.063c1.16,-0.47 2.93,-1.047 4.62,-1.047c1.967,0 3.891,0.506 5.607,1.469c0.382,-0.375 0.732,-0.783 1.05,-1.22c-1.63,-2.141 -2.52,-4.765 -2.52,-7.464c0,-1.818 0.406,-3.622 1.18,-5.261c-1.762,-1.592 -4.01,-2.461 -6.399,-2.461c-4.348,0 -8.133,2.943 -9.241,7.088c3.248,1.89 5.364,5.194 5.703,8.896z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777f8e",
    id: "svg_16",
    d: "m59.117,28.718c0.336,0.534 0.729,1.037 1.175,1.505c1.588,-0.792 3.334,-1.208 5.092,-1.208c1.729,0 3.386,0.442 4.472,0.812c0.34,-4.013 2.767,-7.555 6.4,-9.35c-1.332,-3.805 -4.938,-6.402 -9.021,-6.402c-2.64,0 -5.14,1.084 -6.945,2.992c0.634,1.512 0.955,3.101 0.955,4.73c-0.001,2.495 -0.735,4.873 -2.128,6.921z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg003C11To20People);
export default __webpack_public_path__ + "static/media/003c-11-to-20-people.20d5722b9ed39062d57388c24f760679.svg";
export { ForwardRef as ReactComponent };